export default {
  name: 'FilterCheckbox',
  components: {},
  props: {
    value: {
      type: Array,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    columns: {
      type: Number,
      required: false,
      default: 1,
    },
    placeholder: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    variant: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      open: false,
      selectedItem: this.value,
      showSelectedItem: true,
    };
  },
  created() {
    this.setVariant();
  },
  watch: {},
  computed: {
    listItem() {
      return this.options;
    },
  },
  methods: {
    clickOutSide() {
      this.open = false;
    },
    updateValue() {
      this.$emit('input', this.selectedItem);
    },
    onClickPicker() {
      this.open = !this.open;
    },
    setVariant() {
      if(this.variant === 'config') {
        this.showSelectedItem = false;
      } else {
        this.showSelectedItem = true
      }
    },
  },
};
